import { useUserRecentStore } from "~/stores/useUserRecentStore";

export default defineNuxtRouteMiddleware((to, from) => {
  if (process.client) {
    // Memorize the in-app navigation history.
    useUserRecentStore().addNavigation(to, from);
  }
});
